module.exports = "/images/vendor/flag-icon-css/flags/4x3/pm.svg?1e97e8d76fe2d553eedddc23f833bfe5";